import React from 'react';
import Card from '../components/Card';
import ListWisata from '../components/List/ListWisata';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useState } from 'react';
import axios from 'axios';
import { useEffect } from 'react';
import Hero from '../components/Hero';

export default function Event() {
  const [events, setEvents] = useState('');

  useEffect(() => {
    axios.get('http://localhost:3004/events').then((res) => {
      setEvents(res.data);
      console.log(res.data);
    });
  }, []);
  return (
    <div>
      <Hero
        text="Hadiri Berbagai Event Keren di Daerah Tegal"
        imgSrc="/assets/images/image-event.png"
      />
      <Card
        textLeft="Konser Musik"
        textCenter="Festival Budaya"
        textRight="Festival Lainnya"
        amountLeft={events.length}
        amountCenter={events.length}
        amountRight={events.length}
      />

      <div className="container mx-auto p-[4%] md:grid md:grid-cols-2 grid-cols-none gap-6 items-center font-[Rubik]">
        <div>
          <p className="md:text-2xl text-base text-black font-medium mb-[3%]">Event Populer</p>
          <img src="/assets/images/image-event.png" alt="image-event" className="h-[400px]" />
        </div>
        <div className="md:mt-0 mt-[5%]">
          <p className="md:text-4xl text-xl text-black font-medium">JavaJazz Festival</p>
          <div className="flex items-center">
            <img src="/assets/images/location.svg" alt="location" />
            <p className="md:text-lg text-sm text-[#666666] mx-4">Rita Park, Tegal</p>
            <button className="bg-button border border-button rounded-[100px] px-5 py-2 md:text-base text-xs text-primary">
              Lihat di Map
            </button>
          </div>
          <p className="md:text-base text-xs text-[#999999] mb-6">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed tortor aliquam, congue
            mauris neque, interdum magna diam. Eu magna metus, mauris, ut nunc tellus suspendisse
            risus. Dictum id nisl, nulla malesuada feugiat hendrerit nullam erat pulvinar. Egestas
            mauris eget feugiat commodo sed eget non eget gravida.
          </p>
          <button className="bg-primary text-white md:text-base text-xs px-7 py-3 rounded">
            Explore Sekarang
          </button>
        </div>
      </div>

      <div className="container mx-auto p-[4%]">
        <ListWisata data={events} object="Konser Musik" />
      </div>

      <Footer />
    </div>
  );
}
